import clsx from 'clsx';
import { arrow, arrowOpen } from './dropdown-arrow.css';

export const DropdownArrow = ({ isOpen }: { isOpen: boolean }) => (
  <span className={clsx(arrow, isOpen && arrowOpen)}>›</span>
);
